import React, { Component, Fragment } from 'react';
import Radium from 'radium';
import { getURLParams } from '@widergy/web-utils/lib/browser';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { formValueSelector } from 'redux-form';
import { createSelector } from 'reselect';
import { string, shape, bool } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import BillActions from 'redux/bill/actions';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { ROUTES } from 'constants/routes';
import { ACCOUNT_PAYMENT_DOCS, USER_PAYMENT_DOCS } from 'constants/reduxForms';
import { gaTrackPageView } from 'services/AnalyticsService';
import { message } from 'utils/stringUtils';
import UTBanner from 'app/components/UTBanner';
import Images from 'config/assets';

import { USER_EMAIL, DOCUMENT_TYPE, DOCUMENT_NUMBER, CLIENT_NUMBER, GENDER, NIS } from './constants';
import PaymentsScene from './layout';
import styles from './styles';

class PaymentsSceneContainer extends Component {
  componentDidMount = () => {
    if (this.props.location) {
      const params = getURLParams(this.props.location.search, NIS);
      if (params[NIS]) {
        this.handleURLAccountPaymentDocs(params[NIS]);
      }
    }
    gaTrackPageView(ROUTES.PUBLIC_PAYMENTS);
  };

  handleGoToSignUp = () => this.props.dispatch(push(ROUTES.SIGN_UP));

  handleBackToHome = () => {
    const route = appConfig.publicDashboard.home ? ROUTES.PUBLIC_HOME : ROUTES.PUBLIC_PAYMENTS;
    this.props.dispatch(push(route));
  };

  handleURLAccountPaymentDocs = nisNumber => {
    this.props.dispatch(paymentActions.getPayableDocuments(nisNumber));
    this.props.dispatch(push(ROUTES.PUBLIC_PAYMENT_DOCUMENTS));
  };

  handleSubmitAccountPaymentDocs = () => {
    if (!appConfig.allowPaymentDocumentSelection) {
      this.props.dispatch(
        BillActions.getPublicPaymentDocument(this.props.formValues.clientNumber, this.props.formValues)
      );
    } else {
      this.props.dispatch(paymentActions.getPayableDocuments(this.props.formValues.clientNumber));
      if (this.props.isPrivate) {
        this.props.dispatch(push(ROUTES.EXTERNAL_DOCUMENT_PAYMENTS));
      } else {
        this.props.dispatch(push(ROUTES.PUBLIC_PAYMENT_DOCUMENTS));
      }
    }
  };

  handleSubmitUserPaymentDocs = () => {
    this.props.dispatch(
      paymentActions.getPayableDocuments(
        null,
        this.props.formValues.documentType,
        this.props.formValues.documentNumber,
        this.props.formValues.gender
      )
    );
    if (this.props.isPrivate) {
      this.props.dispatch(push(ROUTES.EXTERNAL_DOCUMENT_PAYMENTS));
    } else {
      this.props.dispatch(push(ROUTES.PUBLIC_PAYMENT_DOCUMENTS));
    }
  };

  render() {
    return (
      <Fragment>
        <div style={styles.container}>
          <UTLabel large bold>
            {appConfig.payments.publicPayment
              ? message('PublicPayment:publicPaymentTitle')
              : message('PublicPayment:publicPaymentDocumentTitle')}
          </UTLabel>
          <PaymentsScene
            loading={this.props.loading}
            documentType={this.props.formValues && this.props.formValues.documentType}
            documentNumber={this.props.formValues && this.props.formValues.documentNumber}
            handleSubmitUserPaymentDocs={this.handleSubmitUserPaymentDocs}
            handleSubmitAccountPaymentDocs={this.handleSubmitAccountPaymentDocs}
            onGoToHome={this.handleBackToHome}
          />
        </div>
        <UTBanner
          loading={this.props.loading}
          imageUrl={Images.bannerSignup}
          containerStyle={styles.bannerContainer}
          customBanner
          onBannerClick={this.handleGoToSignUp}
        />
      </Fragment>
    );
  }
}

const accountPaymentDocsSelector = formValueSelector(ACCOUNT_PAYMENT_DOCS);
const userPaymentDocsSelector = formValueSelector(USER_PAYMENT_DOCS);

export const accountSelector = store => accountPaymentDocsSelector(store, CLIENT_NUMBER);
export const emailSelector = store => accountPaymentDocsSelector(store, USER_EMAIL);
export const documentTypeSelector = store => userPaymentDocsSelector(store, DOCUMENT_TYPE);
export const documentNumberSelector = store => userPaymentDocsSelector(store, DOCUMENT_NUMBER);
export const genderSelector = store => userPaymentDocsSelector(store, GENDER);

export const formValuesSelector = createSelector(
  accountSelector,
  emailSelector,
  documentTypeSelector,
  documentNumberSelector,
  genderSelector,
  (clientNumber, email, documentType, documentNumber, gender) => ({
    clientNumber,
    email,
    documentType,
    documentNumber,
    gender
  })
);

const mapStateToProps = store => ({
  formValues: formValuesSelector(store),
  loading: store.bill.paymentDocumentLoading
});

PaymentsSceneContainer.propTypes = {
  isPrivate: bool,
  loading: bool,
  formValues: shape({
    clientNumber: string,
    email: string,
    documentType: string,
    documentNumber: string,
    gender: string
  }),
  location: shape({
    pathname: string.isRequired,
    search: string
  })
};

export default connect(mapStateToProps)(Radium(PaymentsSceneContainer));
